import AdditionServiceAPI from '@/apis/business/additionServiceAPI'
import CrudBase from '@/stores/crudBase.js'

const apiURL = AdditionServiceAPI.getAPIUrl()

const crudBase = new CrudBase('additionService', AdditionServiceAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
  },
  mutations: {
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
  },
}
